import { differenceInDays, format } from 'date-fns'

export const formatEta = (dateTime) => {
    const n = new Date()
    if (differenceInDays(dateTime, n) !== 0) {
        return format(dateTime, 'yyyy-MM-dd HH:mm')
    }

    return format(dateTime, 'HH:mm')
}
